import React from 'react';
import inputStyles from './styles';
export default function Input({
  data,
  value,
  isValid,
  inputType,
  style,
  ...props
}) {
  const { onChange, onBlur, onFocus } = props;
  const classes = inputStyles();
  const Comp = inputType;

  return (
    <Comp
      {...(inputType === 'input' ? { type: 'text' } : { rows: '3' })}
      ref={data?.refSetter}
      placeholder={data?.metadata?.placeholder}
      value={value}
      className={
        isValid
          ? classes.inputField
          : classes.errorBorder + ' ' + classes.inputField
      }
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      style={style}
    />
  );
}
